export default "__VITE_ASSET__sS8kEaf6__"